import { render, staticRenderFns } from "./AuditVideo.vue?vue&type=template&id=e35850d0&scoped=true"
import script from "./AuditVideo.vue?vue&type=script&lang=ts"
export * from "./AuditVideo.vue?vue&type=script&lang=ts"
import style0 from "./AuditVideo.vue?vue&type=style&index=0&id=e35850d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35850d0",
  null
  
)

export default component.exports